import React from "react";
import imagesConfig from "../../../../../../../../../../configs/images-config";

import style from './HorseItem.module.css';

const HorseItem = (props) => {

    return (
        <div key={props.key} className={style.body} >
            <div
                key={props.key + '_card'}
                className={style.card}
                style={{backgroundImage: 'url(' + props.image + ')'}}
                onClick={props.onClick}
            >
                {props.hide ? <img src={imagesConfig.invisible} alt={'hide_' + props.key} /> : ''}
                <div key={props.key + '_bg'} className={style.bg}>
                    <span key={props.key + '_span'}>{props.name}</span>
                </div>
            </div>
        </div>
    )
};

export default HorseItem;